const newsletter = `
# eBL Newsletter 19

## 4 April 2025

### Library

- Fragmentarium is now called “Library”
- The property acquisition has been added to tablets to indicate the
  individual or institutions from which they were acquired; see e.g.
  [IM.183624](https://www.ebl.lmu.de/library/IM.183624) and
  [MMA-86-11.287.A](https://www.ebl.lmu.de/library/MMA-86-11.287.A)
- Photos and folios
  - New buttons to zoom in on photos and folios have been added.
  - Postgate folios for new, previously unpublished literary texts
    from Kalhu have been added.
  - Ca. 3200 photos from the following collections have been added:
    - British Museum: esp. BM.12335–14118; 1880,0617.2927–3001
    - Hilprecht Collection: esp. HS.1627–1729; HS.2016–2190
    - Iraq Museum: esp. IM.58732–58982
    - Yale Peabody Museum: esp. YBC.2300–5000; YBC.13000–17000
- New collections imported:
  -	Iziko Museums of South Africa (Cape Town)
  - Museum of Archaeology and Anthropology (Cambridge)
  - Museum of Montserrat (Montserrat/Barcelona)
- Archaeological information for all Nippur tablets at the Yale Peabody Museum
  has been imported.
- The Path of the Pioneers now also includes tablets not in the British Museum.
- The issue that caused 500 errors when saving multiple times within a short
  period of time has been corrected.
- The generic documentation of the eBL platform has been redone and expanded.
  It contains both technical and general guides:
  (https://github.com/ElectronicBabylonianLiterature/generic-documentation/tree/master)


### Corpus
- New Corpus editions:
  - [*Enūma Anu Enlil* 55](https://www.ebl.lmu.de/corpus/D/1/4/SB/55) by
    M. T. Renzi-Sepe and L. Sáenz
  - [*Enūma Anu Enlil* 57](https://www.ebl.lmu.de/corpus/D/1/4/SB/57) by
    M. T. Renzi-Sepe and L. Sáenz
  - [*šuʾilas* to Adad](https://www.ebl.lmu.de/corpus/Mag/2/1) by A. Lenzi


### Tools and projects

- A new interface for displaying bibliographical references has been
  implemented. It is now possible to download references in various formats.
-	Sign list: The palaeographic collection has been expanded in the framework of
  the KUKI project. Thanks to the work of the student assistants Mays Fadhil,
  Louisa Grill, Or Lewenstein and Albert Setälä, the number of Old Babylonian
  signs now amounts to 34,370; the total number of annotated signs is 91,894.
- “Projects” have been fully implemented. When certain texts in the Library are
  linked to projects, the interface enables searching through them. In
  addition, info pages can be added.

- **eBL Evenings**: : We will be hosting regular Zoom sessions to showcase its
  features and tools. These sessions will include a Q&A – please feel free to
  submit questions in advance via [e-mail](mailto:ebl-info@culture.lmu.de). The
  third session is scheduled for April 25that 6:00 PM CET. If you would like to
  attend, please register at the
  [link](https://lmu-munich.zoom-x.de/meeting/register/hdYUYZ7-TJeVml8Ge5MZdA).`

export default newsletter
